import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useLang, OVERRIDE_REASONS, reasonLabel } from "@/lib/i18n";

/* Flag: requires a note. Override: requires reason code + note (spec §8). */
export const ReasonDialog = ({ open, onOpenChange, mode, onSubmit, busy }) => {
  const { t } = useLang();
  const [note, setNote] = useState("");
  const [reason, setReason] = useState("");
  const isOverride = mode === "override";
  const valid = note.trim().length > 0 && (!isOverride || reason);

  const handleOpenChange = (v) => {
    if (!v) { setNote(""); setReason(""); }
    onOpenChange(v);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent data-testid="reason-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{isOverride ? t("override") : t("flag")}</DialogTitle>
          <DialogDescription>
            {isOverride ? t("overrideNoteRequired") : t("flagNoteRequired")}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {isOverride && (
            <div className="space-y-1.5">
              <Label>{t("reasonCode")}</Label>
              <Select value={reason} onValueChange={setReason}>
                <SelectTrigger data-testid="override-reason-select">
                  <SelectValue placeholder={t("reasonCode")} />
                </SelectTrigger>
                <SelectContent>
                  {OVERRIDE_REASONS.map((r) => (
                    <SelectItem key={r} value={r} data-testid={`override-reason-${r}`}>
                      {reasonLabel(t, r)}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <div className="space-y-1.5">
            <Label>{t("note")}</Label>
            <Textarea
              data-testid="reason-note-input"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              maxLength={2000}
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => handleOpenChange(false)} data-testid="reason-cancel-button">
            {t("cancel")}
          </Button>
          <Button
            type="button"
            data-testid="reason-submit-button"
            disabled={!valid || busy}
            onClick={async () => {
              await onSubmit({ note: note.trim(), reasonCode: isOverride ? reason : undefined });
              handleOpenChange(false);
            }}
          >
            {isOverride ? t("override") : t("flag")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
